"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var selectable_row_1 = require("../../selectable-row");
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  background-color: #fff;\n"], ["\n  background-color: #fff;\n"])));
function Item(props) {
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(selectable_row_1.SelectableRow, (0, tslib_1.__assign)({}, props))));
}
exports.Item = Item;
var templateObject_1;
//# sourceMappingURL=item.js.map